import React, { useEffect, useState } from 'react';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { useFormik } from 'formik';
import { Button, Card } from 'react-bootstrap';
import { Customer, NewCustomerModalProps } from '../../customers/CustomerInterfaces';
import { db } from '../../../../firebase';
import { collection } from 'firebase/firestore';

interface SelectedClientDetailsProps extends Partial<NewCustomerModalProps> {
  customerId: string | null;
}

const SelectedClientDetails: React.FC<SelectedClientDetailsProps> = ({ customerId }) => {
  const [customer, setCustomer] = useState<Customer | null>(null);
  const [isSaving, setIsSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);

  useEffect(() => {
    const fetchCustomer = async () => {
      if (customerId) {
        const customerDoc = await getDoc(doc(db, 'customers', customerId));
        if (customerDoc.exists()) {
          setCustomer(customerDoc.data() as Customer);
        } else {
          console.log('No such document!');
        }
      }
    };

    fetchCustomer();
  }, [customerId]);

  const formik = useFormik({
    initialValues: customer || {
      name: '',
      contacts: [],
      email: '',
      phone: '',
      address: '',
      company: '',
      industry: '',
      notes: '',
      createdAt: '',
      lastContacted: '',
      // Add more fields as needed
    },

    onSubmit: async (values: Customer) => {
        if (customerId) {
          setIsSaving(true);
          const customerRef = doc(db, 'customers', customerId);
          await updateDoc(customerRef, values as { [x: string]: any });
          setIsSaving(false);
          setSaveSuccess(true);
        }
      },
    // Add validation schema or validate function
    enableReinitialize: true, // Add this line
  });

  return (
    <div className="container">
      <Card>
        <Card.Header>
          <Card.Title>Customer Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <form onSubmit={formik.handleSubmit}>
          <div className="row">
  <div className="col-md-6">
    <div className="mb-3">
      <label htmlFor="name" className="form-label">Primary Contact</label>
      <input type="text" className="form-control" id="name" {...formik.getFieldProps('name')} />
      {formik.touched.name && formik.errors.name && <div className="text-danger">{formik.errors.name}</div>}
    </div>
  </div>
  <div className="col-md-6">
    <div className="mb-3">
      <label htmlFor="email" className="form-label">Primary Email</label>
      <input type="email" className="form-control" id="email" {...formik.getFieldProps('email')} />
      {formik.touched.email && formik.errors.email && <div className="text-danger">{formik.errors.email}</div>}
    </div>
  </div>
</div>
{/* Add Secondary Contact fields and logic */}
{formik.values.contacts && formik.values.contacts.map((contact, index) => (
  <div key={index}>
    <hr style={{borderTop: '1px dashed var(--bs-border-color)'}} />
    <div className="row">
      <div className="col-md-4">
        <div className="mb-3">
          <label htmlFor={`contacts[${index}].name`} className="form-label">Secondary Contact Name</label>
          <input type="text" className="form-control" id={`contacts[${index}].name`} {...formik.getFieldProps(`contacts[${index}].name`)} />
        </div>
      </div>
      <div className="col-md-4">
        <div className="mb-3">
          <label htmlFor={`contacts[${index}].email`} className="form-label">Secondary Contact Email</label>
          <input type="email" className="form-control" id={`contacts[${index}].email`} {...formik.getFieldProps(`contacts[${index}].email`)} />
        </div>
      </div>
      <div className="col-md-4">
        <div className="mb-3">
          <label htmlFor={`contacts[${index}].phone`} className="form-label">Secondary Contact Phone</label>
          <input type="text" className="form-control" id={`contacts[${index}].phone`} {...formik.getFieldProps(`contacts[${index}].phone`)} />
        </div>
      </div>
      <div className="col-md-4">
  <button type="button" className="btn btn-link p-0" onClick={() => {
    const newContacts = [...formik.values.contacts];
    newContacts.splice(index, 1);
    formik.setFieldValue('contacts', newContacts);
  }}><i className="bi bi-trash fs-3"></i></button>
</div>
    </div>
    <hr style={{borderTop: '1px dashed var(--bs-border-color)'}} />
  </div>
))}

<Button className='btn Primarys' style={{ marginTop: '20px', marginBottom: '20px' }} onClick={() => formik.setFieldValue('contacts', [...formik.values.contacts, { name: '', email: '', phone: '' }])}>Add Secondary Contact</Button>

 {/* Add Secondary Contact fields and logic END */}   
{/* Phone and Address */}
<div className="row">
  <div className="col-md-6">
    <div className="mb-3">
      <label htmlFor="phone" className="form-label">Phone Number</label>
      <input type="text" className="form-control" id="phone" {...formik.getFieldProps('phone')} />
      {formik.touched.phone && formik.errors.phone && <div className="text-danger">{formik.errors.phone}</div>}
    </div>
  </div>
  <div className="col-md-6">
    <div className="mb-3">
      <label htmlFor="address" className="form-label">Address</label>
      <input type="text" className="form-control" id="address" {...formik.getFieldProps('address')} />
      {formik.touched.address && formik.errors.address && <div className="text-danger">{formik.errors.address}</div>}
    </div>
  </div>
</div>
              <div className="row">
  <div className="col-md-6">
    <div className="mb-3">
      <label htmlFor="company" className="form-label">Company</label>
      <input type="text" className="form-control" id="company" {...formik.getFieldProps('company')} />
      {formik.touched.company && formik.errors.company && <div className="text-danger">{formik.errors.company}</div>}
    </div>
  </div>
  <div className="col-md-6">
    <div className="mb-3">
      <label htmlFor="industry" className="form-label">Industry</label>
      <input type="text" className="form-control" id="industry" {...formik.getFieldProps('industry')} />
      {formik.touched.industry && formik.errors.industry && <div className="text-danger">{formik.errors.industry}</div>}
    </div>
  </div>
</div>
              {/* Notes */}
              <div className="mb-3">
                <label htmlFor="notes" className="form-label">Notes</label>
                <textarea className="form-control" id="notes" {...formik.getFieldProps('notes')}></textarea>
                {formik.touched.notes && formik.errors.notes && <div className="text-danger">{formik.errors.notes}</div>}
              </div>
              <div className="row">
  <div className="col-md-6">
    <div className="mb-3">
      <label htmlFor="createdAt" className="form-label">Created At</label>
      <input type="date" className="form-control" id="createdAt" {...formik.getFieldProps('createdAt')} />
      {formik.touched.createdAt && formik.errors.createdAt && <div className="text-danger">{formik.errors.createdAt}</div>}
    </div>
  </div>
  <div className="col-md-6">
    <div className="mb-3">
      <label htmlFor="lastContacted" className="form-label">Last Contacted</label>
      <input type="date" className="form-control" id="lastContacted" {...formik.getFieldProps('lastContacted')} />
      {formik.touched.lastContacted && formik.errors.lastContacted && <div className="text-danger">{formik.errors.lastContacted}</div>}
    </div>
  </div>
</div>
<Button type="submit" variant="primary" className="mb-3">Save Customer</Button>
{saveSuccess && <div className="alert alert-success mt-3">Customer details saved successfully!</div>}
          </form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default SelectedClientDetails;